import React from 'react';
import { useAppStore } from '../store/useAppStore';
import { formatDate } from '../lib/utils';
import { Activity, Calendar } from 'lucide-react';

const HistoryPage = () => {
  const sessions = useAppStore(state => state.sessions);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-slate-900">Practice History</h1>

      {sessions.length === 0 ? (
        <div className="bg-white rounded-xl p-12 text-center border border-slate-200">
            <Activity className="h-12 w-12 text-slate-300 mx-auto mb-4" />
            <p className="text-slate-500">No practice sessions completed yet.</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
            <table className="min-w-full divide-y divide-slate-200">
                <thead className="bg-slate-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Date</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Questions</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Score</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Status</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-slate-200">
                    {sessions.map((session) => (
                        <tr key={session.id} className="hover:bg-slate-50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                                <div className="flex items-center">
                                    <Calendar className="h-4 w-4 text-slate-400 mr-2" />
                                    {formatDate(session.started_at)}
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-500">
                                {session.total_questions}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <span className="font-bold text-slate-900">{session.score_percentage}%</span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                    session.score_percentage >= 80 ? 'bg-green-100 text-green-800' : 
                                    session.score_percentage >= 50 ? 'bg-yellow-100 text-yellow-800' : 
                                    'bg-red-100 text-red-800'
                                }`}>
                                    {session.score_percentage >= 80 ? 'Excellent' : session.score_percentage >= 50 ? 'Good' : 'Needs Work'}
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
      )}
    </div>
  );
};

export default HistoryPage;